import { createApp } from "vue";
import { createPinia } from "pinia";
import { Tooltip } from "bootstrap";
import App from "./App.vue";
import { register } from "register-service-worker";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import vSelect from "vue-select";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import { defineRule, configure } from "vee-validate";
import AllRules from "@vee-validate/rules";
import { localize, setLocale } from "@vee-validate/i18n";
import fa from "@vee-validate/i18n/dist/locale/fa.json";
import OpenLayersMap from "vue3-openlayers";
import moment from "jalali-moment";
import "virtual:uno.css";



if (import.meta.env.NODE_ENV === 'production') {
  register(`${import.meta.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('Service worker is active.');
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.use(OpenLayersMap);
app.component("v-select", vSelect);
app.component("DatePicker", Vue3PersianDatetimePicker);
// register("/najva-messaging-sw.js");
localize({ fa });
configure({
  generateMessage: localize("fa", {
    names: {
      firstName: "نام",
      lastName: "نام خانوادگی",
      nationalCode: "کد ملی",
      mobile: "شماره موبایل",
      companyName: "نام شرکت",
      companyNationalCode: "کد ملی شرکت",
      guild: "حوزه فعالیت",
      role: "نقش",
      birthDate: "تاریخ تولد",
      education: "تحصیلات",
      userType: "نوع کاربر",
      gender: "جنسیت",
    },
  }),
});

setLocale("fa");
Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});

ApiService.init(app);

initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.directive("tooltip", (el) => {
  new Tooltip(el);
});

app.mount("#app");
